<template>
    <form-builder :url="url" :method="method" :fields="fields" :argsdata="args.bug" :success="onSuccess"></form-builder>
</template>

<script>
    import FormBuilder from './FormBuilder';
    export default {
        components: {
            FormBuilder
        },
        props: {
            args: Object
        },
        created() {
        },
        mounted() {
        },
        methods: {
            onSuccess() {
                location.href = "/bugs";
            }
        },
        data() {
            return {
                url: '/bugs',
                method: 'post',
                fields: [
                    {type: 'text', name: 'title', label: __('bugs.title')},
                    {type: 'hidden', name: 'bugtype'},
                    {type: 'textarea', name: 'description', label: __('bugs.description')},
                    {type: 'submit', name: __('bugs.add')}
                ]
            }

        }
    }
</script>
